import { render, staticRenderFns } from "./OnboardingModal.vue?vue&type=template&id=0540ace0&"
import script from "./OnboardingModal.vue?vue&type=script&lang=ts&"
export * from "./OnboardingModal.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports